import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53380ca6")

_pushScopeId("data-v-53380ca6")
const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "control-label" }, " Automatisk deaktivér bruger efter (0 = slået fra): ", -1)
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "d-flex input-with-suffix" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "suffix mt-2" }, "dage", -1)
const _hoisted_7 = { class: "flex flex-column mt-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "control-label" }, " Automatisk slet bruger efter yderligere (0 = slået fra): ", -1)
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "d-flex input-with-suffix" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "suffix mt-2" }, "dage", -1)
const _hoisted_13 = { class: "flex flex-column" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "control-label" }, " Send notifikationsmails til modtager(e), hvis der ikke findes lokal administrator: ", -1)
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-md" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Tilføj ")
const _hoisted_18 = { class: "mt-3" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Vi fandt ")
const _hoisted_20 = { class: "text-primary" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" modtagere")
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = { class: "d-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NotificationOptionsModal = _resolveComponent("NotificationOptionsModal")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_FormErrors = _resolveComponent("FormErrors")!
  const _component_Button = _resolveComponent("Button")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_NotificationOptionsModal, {
      onReloadEmailsNotification: _ctx.onReloadEmailsNotification,
      ref: "notificationOptionsModal"
    }, null, 8, ["onReloadEmailsNotification"]),
    _createVNode(_component_page, {
      isLoading: _ctx.loading,
      error: _ctx.error || undefined
    }, {
      default: _withId(() => [
        _createVNode(_component_AppHeader, {
          classContainerAppHeader: "mt-5",
          classSubtitle: "mt-1 d-flex",
          title: "Deaktivering og sletning"
        }),
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_o_field, {
              style: {"width":"10%"},
              variant: 
            _ctx.vueValidation$.deactivateUserAfterInDays.$error ? 'danger' : ''
          
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_o_input, {
                    modelValue: _ctx.deactivateUserAfterInDays,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.deactivateUserAfterInDays = $event)),
                    class: {
                invalid: _ctx.vueValidation$.deactivateUserAfterInDays.$error,
              },
                    onInput: _ctx.handleDeactivateUserAfterInDaysInput,
                    onBlur: _ctx.onUpdateDeactivateSettingBlur
                  }, null, 8, ["modelValue", "class", "onInput", "onBlur"]),
                  _hoisted_5,
                  _hoisted_6
                ])
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _createVNode(_component_FormErrors, {
            errors: _ctx.vueValidation$.deactivateUserAfterInDays.$errors
          }, null, 8, ["errors"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_o_field, {
              style: {"width":"10%"},
              variant: 
            _ctx.vueValidation$.deleteUserAfterAdditionalInDays.$error
              ? 'danger'
              : ''
          
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_o_input, {
                    modelValue: _ctx.deleteUserAfterAdditionalInDays,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteUserAfterAdditionalInDays = $event)),
                    class: {
                invalid: _ctx.vueValidation$.deleteUserAfterAdditionalInDays.$error,
              },
                    onInput: _ctx.handleDeleteUserAfterAdditionalInDaysInput,
                    onBlur: _ctx.onUpdateDeletionSettingBlur
                  }, null, 8, ["modelValue", "class", "onInput", "onBlur"]),
                  _hoisted_11,
                  _hoisted_12
                ])
              ]),
              _: 1
            }, 8, ["variant"])
          ]),
          _createVNode(_component_FormErrors, {
            errors: _ctx.vueValidation$.deleteUserAfterAdditionalInDays.$errors
          }, null, 8, ["errors"])
        ]),
        (_ctx.notificationEmails)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_AppHeader, {
                classContainerAppHeader: "mt-5",
                classSubtitle: "mt-1 d-flex",
                title: "Notifikationsliste"
              }),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_o_field, {
                      variant: _ctx.vueValidation$.newEmail.$error ? 'danger' : ''
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_o_input, {
                          modelValue: _ctx.newEmail,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newEmail = $event)),
                          class: { invalid: _ctx.vueValidation$.newEmail.$error },
                          onInput: _ctx.handleInputEmail
                        }, null, 8, ["modelValue", "class", "onInput"])
                      ]),
                      _: 1
                    }, 8, ["variant"]),
                    _createVNode(_component_FormErrors, {
                      errors: _ctx.vueValidation$.newEmail.$errors
                    }, null, 8, ["errors"]),
                    _createVNode(_component_Button, {
                      class: "primary mt-2 px-4 float-right",
                      onClick: _ctx.onAddNotificationEmail,
                      disabled: _ctx.vueValidation$.newEmail.$error || _ctx.newEmail === '',
                      style: {"float":"right"}
                    }, {
                      default: _withId(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("strong", null, [
                    _hoisted_19,
                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.notificationEmails.count), 1),
                    _hoisted_21
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_DataTable, {
                    class: "bg-white rounded text-start",
                    sortField: "emailAddress",
                    responsiveLayout: "scroll",
                    value: _ctx.notificationEmails.items ?? [],
                    selectionMode: "single",
                    onRowClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.notificationOptionsModal?.show($event.data)))
                  }, {
                    empty: _withId(() => [
                      _createVNode(_component_error, { error: {
                  title: 'Ingen e-mail',
                  message: 'Der er ikke oprettet nogen e-mails endnu',
                } })
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_Column, {
                        sortable: true,
                        field: "emailAddress"
                      }, {
                        body: _withId(({ data }) => [
                          _createVNode("strong", null, _toDisplayString(data.emailAddress), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, null, {
                        body: _withId(({ data }) => [
                          _createVNode("div", _hoisted_23, [
                            _createVNode(_component_Button, {
                              class: "ms-auto appension rounded-circle inverted p-2 me-3",
                              type: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.onDeleteNotificationEmail(data)), ["stop"])
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isLoading", "error"])
  ], 64))
})